import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import {
  ControlLabel,
  Button,
  Form,
  FormGroup,
  FormControl,
} from 'react-bootstrap';
import authHeader from '../services/AuthHeader';
import SimpleReactValidator from 'simple-react-validator';
import AuthService from '../services/AuthService';
import { useHistory } from 'react-router-dom';

const Statement = (props) => {
  let history = useHistory();
  const simpleValidator = useRef(
    new SimpleReactValidator({ className: 'text-danger' })
  );
  const [showSubmit, setShowSubmit] = useState(true);
  const [candidateId, setCandidateId] = useState();
  let allValid = simpleValidator.current.allValid();
  useEffect(() => {
    if (allValid) {
      setShowSubmit(false);
    } else {
      setShowSubmit(true);
    }
  }, [allValid]);

  /* Get candidate statement and image */
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_BASE +
          'candidateprofile/' +
          AuthService.getStarId(),
        { headers: authHeader() }
      )
      .then((res) => {
        setStatement(res.data.candidateStatement);
        if (res.data.imageFileName !== null && res.data.imageFileName !== '') {
          setImage({
            image_preview:
              process.env.REACT_APP_API_BASE +
              'imageview/' +
              res.data.candidateId +
              '_' +
              res.data.imageFileName,
          });
        }
      });
  }, []);

  /* Get candidate Id */
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_BASE +
          'candidateid/' +
          AuthService.getStarId(),
        { headers: authHeader() }
      )
      .then((res) => {
        setCandidateId(res.data.candidateId);
      });
  }, []);

  const { setRerenderListings, ...modalProps } = props;
  const initImage = {
    image_file: null,
    image_preview: '',
  };
  const [statement, setStatement] = useState('');
  const [imageTitle, setImageTitle] = useState('');
  const [image, setImage] = useState(initImage);

  // Image Title Handler
  const handleStatement = (e) => {
    setStatement(e.target.value);
  };

  // Image Preview Handler
  const handleImagePreview = (e) => {
    let image_as_base64 = URL.createObjectURL(e.target.files[0]);
    let image_as_files = e.target.files[0];
    var extension = e.target.files[0].type.replace(/(.*)\//g, '');
    setImageTitle(e.target.files[0].name);
    setImage({
      image_preview: image_as_base64,
      image_file: image_as_files,
      image_ext: extension,
    });
  };

  // Image/File Submit Handler
  const handleSubmitFile = (e) => {
    e.preventDefault();

    const candidate = {
      BallotCandidateId: candidateId,
      CandidateStatement: statement,
      CandidateStatus: 'u',
    };

    axios
      .put(
        process.env.REACT_APP_API_BASE + 'candidatestatement/' + candidateId,
        candidate,
        { headers: authHeader() }
      )
      .then((res) => console.log('success ', res.data));

    let imageAuthHeader = authHeader();
    imageAuthHeader['Content-type'] = 'multipart/form-data';
    if (image.image_file !== null) {
      let formData = new FormData();
      formData.append('CandidateId', candidateId);
      formData.append('ImageBlob', image.image_file);
      formData.append('ImageFileName', imageTitle);
      formData.append('ImageFileType', 'image/' + image.image_ext);

      axios
        .post(process.env.REACT_APP_API_BASE + 'imageupload/', formData, {
          headers: imageAuthHeader,
        })
        .then((res) => {
          setImage(initImage);
          setImageTitle('');
          history.push({
            pathname: '/viewcandidate',
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      <h1 className='h2'>Candidate Statement and Photo</h1>
      <Form>
        <FormGroup controlId='image'>
          <img
            className='center-preview'
            style={{
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto',
              width: '50%',
            }}
            src={
              image.image_file !== null
                ? image.image_preview
                : 'no-picture-available-icon.jpg'
            }
            alt='Candidate profile preview'
          />
          <ControlLabel>Candidate Photo</ControlLabel>
          <FormControl
            style={{
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto',
              width: '50%',
            }}
            type='file'
            accept='image/*'
            onChange={handleImagePreview}
            autoComplete='off'
            name='image'
            aria-label='Upload candidate photo'
            className='btn btn-default'
          ></FormControl>
        </FormGroup>
        <FormGroup controlId='formControlsTextarea'>
          <ControlLabel>Statement:</ControlLabel>
          <FormControl
            componentClass='textarea'
            onChange={handleStatement}
            value={statement}
            placeholder='Enter statement here'
            style={{ height: 200, backgroundColor: 'white' }}
          />
        </FormGroup>
        <Button
          className='btn btn-default'
          type='submit'
          onClick={handleSubmitFile}
          disabled={showSubmit}
        >
          Save
        </Button>
      </Form>
    </>
  );
};

export default Statement;
